import MikomiData from "./MikomiData";

export default class MikomiKeikaku
{
    constructor(revision)
    {
        this.Revision = revision;
        this.Data = new MikomiData();
    }
}